import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import {locationShape} from 'react-router';

import {loadFilesByQuery} from 'overview/actions/queryFiles';
import File from 'common/components/File/File';
import LazyLoadingScrollList from 'common/components/LazyLoadingScrollList/LazyLoadingScrollList';

class QueryFiles extends Component {
    componentDidMount(){
        const queryJson = JSON.stringify(this.convertQueryParamsToArray(this.props.location.query));
        this.props.loadFilesByQuery(queryJson);
    }

    render() {
        const fileFactory = dataItem => {
            return <File document={dataItem} isUnfiledDocuments={false} locationPath='files' />;
        };

        return <LazyLoadingScrollList data={this.props.documents} componentFactory={fileFactory} />;
    }

    convertQueryParamsToArray(queryParams) {
        const keys = Object.keys(queryParams);

        const data = {};
        keys.forEach((key) => {
            const value = queryParams[key];
            const [documentType, descriptor] = key.split('_');
            if (documentType && descriptor) {
                data[documentType] = data[documentType] || {};
                data[documentType].descriptors = data[documentType].descriptors || {};
                if (data[documentType].descriptors[descriptor]) {
                    [data[documentType].descriptors[descriptor], value].join(',');
                } else {
                    data[documentType].descriptors[descriptor] = value;
                }
            }
        });
        return data;
    }
}

QueryFiles.contextTypes = {
    router: PropTypes.object.isRequired,
    location: locationShape.isRequired
};


const mapStateToProps = function(state) {
    let documents = [];
    if (state.queryFiles) {
        documents = state.queryFiles.documents || [];
    }
    return {
        documents: documents
    };
};
const mapDispatchToProps = {
    loadFilesByQuery
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryFiles);
